import Header from "components/Common/Header/Header";

import ReportListViewBody from "components/ChallengeComponents/FullReport/ListView/ReportListViewBody";

import React, { useEffect } from "react";

const GlobalReportList = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Challenges";
  }, []);
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="challenges" />

      <ReportListViewBody />
    </main>
  );
};

export default GlobalReportList;
